// src/components/LoadingSpinner.tsx

import React from 'react';

const LoadingSpinner: React.FC<{ size?: number, className?: string }> = ({
  size = 32,
  className = ''
}) => {
  return (
    <div className={`animate-spin ${className}`} style={{ width: size, height: size }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full text-content-muted"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinner;
